import { push } from "../Utils/utils"

export function showFlows() {
	return push("/flows")
}
